(function () {
  var root = document.querySelector('[data-ss-collection]');
  if (!root || root.dataset.ssReady) return;
  root.dataset.ssReady = '1';

  var html = document.documentElement;
  var mobile = window.matchMedia('(max-width: 989px)');
  var cache = {};
  var controller = null;
  var timer = null;
  var pendingUrl = null;

  function $(sel) { return root.querySelector(sel); }
  function form() { return document.getElementById('ss-filter-form') || document.getElementById('ss-sort-form'); }
  function panel() { return $('[data-ss-filters]'); }
  function isOpen() { var p = panel(); return !!p && p.classList.contains('is-open'); }

  function formUrl() {
    var f = form();
    var params = new URLSearchParams();
    new FormData(f).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    var query = params.toString();
    return f.getAttribute('action') + (query ? '?' + query : '');
  }

  function fetchDoc(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    if (controller) controller.abort();
    controller = new AbortController();
    return fetch(url, { signal: controller.signal, credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        cache[url] = doc;
        return doc;
      });
  }

  function openState() {
    var state = {};
    root.querySelectorAll('details[data-group]').forEach(function (d) { state[d.dataset.group] = d.open; });
    return state;
  }

  function swap(doc) {
    var state = openState();
    var body = $('[data-ss-filter-body]');
    var scroll = body ? body.scrollTop : 0;
    var focusId = document.activeElement && document.activeElement.id;

    ['[data-ss-results]', '[data-ss-filter-body]', '[data-ss-count]', '[data-ss-btn-count]', '[data-ss-apply]'].forEach(function (sel) {
      var next = doc.querySelector(sel);
      var current = $(sel);
      if (next && current) current.innerHTML = next.innerHTML;
    });

    root.querySelectorAll('details[data-group]').forEach(function (d) {
      if (d.dataset.group in state && !d.querySelector('input:checked')) d.open = state[d.dataset.group];
    });
    body = $('[data-ss-filter-body]');
    if (body) body.scrollTop = scroll;
    if (focusId) {
      var el = document.getElementById(focusId);
      if (el) el.focus({ preventScroll: true });
    }
    initPrice();
    if (window.jdgm && typeof window.jdgm.init === 'function') {
      try { window.jdgm.init(document, true); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('ss:collection:updated'));
  }

  function go(url, push) {
    var results = $('[data-ss-results]');
    if (results) results.classList.add('is-loading');
    return fetchDoc(url).then(function (doc) {
      swap(doc);
      if (push !== false) history.pushState({ ss: 1 }, '', url);
      pendingUrl = null;
      closeDrawer();
      results = $('[data-ss-results]');
      if (results) results.classList.remove('is-loading');
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      window.location.href = url;
    });
  }

  function preview(url) {
    pendingUrl = url;
    var apply = $('[data-ss-apply]');
    fetchDoc(url).then(function (doc) {
      if (pendingUrl !== url) return;
      var next = doc.querySelector('[data-ss-apply]');
      if (next && apply) apply.innerHTML = next.innerHTML;
    }).catch(function () {});
  }

  function changed(immediate) {
    clearTimeout(timer);
    var run = function () {
      var url = formUrl();
      if (mobile.matches && isOpen()) preview(url); else go(url);
    };
    if (immediate) run(); else timer = setTimeout(run, 600);
  }

  function openDrawer() {
    var p = panel();
    if (!p || !mobile.matches) return;
    p.classList.add('is-open');
    html.classList.add('ss-lock');
    var btn = $('[data-ss-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var close = p.querySelector('[data-ss-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var p = panel();
    if (!p) return;
    p.classList.remove('is-open');
    html.classList.remove('ss-lock');
    var btn = $('[data-ss-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function initPrice() {
    var wrap = $('[data-ss-price]');
    if (!wrap) return;
    var lo = parseFloat(wrap.dataset.min);
    var hi = parseFloat(wrap.dataset.max);
    var ranges = wrap.querySelectorAll('input[type="range"]');
    var nums = wrap.querySelectorAll('input[type="number"]');
    var span = hi - lo || 1;
    function paint() {
      wrap.style.setProperty('--lo', ((ranges[0].value - lo) / span * 100) + '%');
      wrap.style.setProperty('--hi', ((ranges[1].value - lo) / span * 100) + '%');
    }
    ranges[0].addEventListener('input', function () {
      if (+ranges[0].value > +ranges[1].value) ranges[0].value = ranges[1].value;
      nums[0].value = +ranges[0].value <= lo ? '' : ranges[0].value;
      paint();
    });
    ranges[1].addEventListener('input', function () {
      if (+ranges[1].value < +ranges[0].value) ranges[1].value = ranges[0].value;
      nums[1].value = +ranges[1].value >= hi ? '' : ranges[1].value;
      paint();
    });
    nums[0].addEventListener('input', function () { ranges[0].value = nums[0].value === '' ? lo : nums[0].value; paint(); });
    nums[1].addEventListener('input', function () { ranges[1].value = nums[1].value === '' ? hi : nums[1].value; paint(); });
    paint();
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.closest('#ss-filter-form') && (t.type === 'checkbox' || t.type === 'radio')) changed(true);
    else if (t.matches('[data-ss-sort]')) go(formUrl());
  });

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.closest('#ss-filter-form') && (t.type === 'number' || t.type === 'range')) changed(false);
  });

  root.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(timer);
    go(formUrl());
  });

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ss-open]')) { openDrawer(); return; }
    if (t.closest('[data-ss-close]') || t.closest('[data-ss-backdrop]')) { closeDrawer(); return; }
    var link = t.closest('a[data-ss-link], .pagination a');
    if (link && link.href && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0) {
      e.preventDefault();
      go(link.href).then(function () {
        if (link.closest && document.querySelector('.pagination') && /[?&]page=/.test(link.href)) {
          var top = root.getBoundingClientRect().top + window.pageYOffset - 16;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { closeDrawer(); var b = $('[data-ss-open]'); if (b) b.focus(); }
  });

  window.addEventListener('popstate', function () { go(window.location.href, false); });
  var onBreakpoint = function () { if (!mobile.matches) closeDrawer(); };
  if (mobile.addEventListener) mobile.addEventListener('change', onBreakpoint); else mobile.addListener(onBreakpoint);

  initPrice();
})();
